import React, { Fragment } from 'react';
import { isAfter } from 'date-fns';
import { useTranslation } from 'react-i18next';
import SvgMegaphone from '../../../../play-core/icons/Megaphone';
import { Colors } from '../../../../play-core/styles/Colors';
import { useAbTest } from '../../hooks/use-ab-test';
import { FloatingButton } from '../ClickableComponents/FloatingButton';
import { useDialogDispatch } from '../Dialog/DialogContext';
import { FeatureSurveyDialog } from '../Dialog/FeatureSurvey/FeatureSurveyDialog';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureSurvey = ({
  title,
  text,
  surveyLink,
  dueDate,
  validation
}) => {
  const {
    t
  } = useTranslation();
  const dialogDispatch = useDialogDispatch();
  const group = useAbTest(validation?.abTestName);
  const isValid = validation ? validation.allowedGroups.includes(group) : true;
  return /*#__PURE__*/_jsx(Fragment, {
    children: isFeatureSurveyActive({
      dueDate
    }) && isValid && /*#__PURE__*/_jsx(FloatingButton, {
      type: "icon",
      onClick: () => dialogDispatch({
        type: 'show-dialog',
        dialog: /*#__PURE__*/_jsx(FeatureSurveyDialog, {
          title: title,
          text: text,
          surveyLink: surveyLink[group] ?? surveyLink.A
        })
      }),
      ariaLabel: t('global.participateFeedback'),
      iconSize: 48,
      icon: /*#__PURE__*/_jsx(SvgMegaphone, {}),
      colorSet: {
        backgroundColor: Colors.CYAN_45b39c,
        hoverBackgroundColor: Colors.CYAN_45b39c,
        activeBackgroundColor: Colors.CYAN_45b39c
      }
    })
  });
};
export const isFeatureSurveyActive = survey => survey && isAfter(new Date(survey.dueDate), new Date());